// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeaturesList-modulewrapper3sq"};